import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-122d0e6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language-container" }

import { useI18n } from "vue-i18n";
import { useUserStore } from "@/store/userStore";
import { ref, onMounted, watch } from "vue";
import type { Language } from "@/store/userStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

const { locale } = useI18n();
const userStore = useUserStore();
const selectedLanguage = ref<Language>(userStore.language as Language);
const languages = [
  { value: "ee", title: "Ee" },
  { value: "ru", title: "Ru" },
];

onMounted(() => {
  locale.value = selectedLanguage.value;
});

// Watch for changes to selectedLanguage
watch(selectedLanguage, (newLanguage) => {
  console.log("Watcher Triggered: Language to change is", newLanguage);
  locale.value = newLanguage;
  userStore.setLanguage(newLanguage);
});

const changeLanguage = (value: Language) => {
  // console.log("Changing Language to:", value);
  selectedLanguage.value = value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      modelValue: selectedLanguage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
      items: languages,
      "item-value": "value",
      "item-title": "title",
      onChange: changeLanguage,
      class: "language-selector",
      density: "compact"
    }, null, 8, ["modelValue"])
  ]))
}
}

})